import React, { useEffect } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import style from "./style";
import TiktokLoginIcon from "../../../../../assets/icons/tiktok_icon.webp";
import IconSuccess from "../../../../Icons/SuccessIcon";
import _ from "lodash";

const useStyles = makeStyles(() => createStyles(style()));

type props = {
  appid: any;
  redirectURL: any;
  rid: any;
  AuthGroup: any;
  onTTResponse?: any;
};

export const TiktokAuth = (props: props): JSX.Element => {
  const classes = useStyles();
  const { appid, rid, AuthGroup,onTTResponse } = props;
  const visibllity = (!_.isEmpty(AuthGroup.value) && !_.isNull(AuthGroup.value)) ? "visible" : "hidden";

  useEffect(() => {
    const channel = new BroadcastChannel("tt-auth-channel");
    channel.onmessage = (e) => {
      if (e.data.redirect) {
        const Params = new URLSearchParams(e.data.redirect);
        const authcode = Params.get("auth_code");
        onTTResponse(authcode);
      }
      return () => channel.close();
    };
  }, []);

  const openNewTab = (): void => {
    const state = {targetCallback : `${window.origin}/tt/callback`,
      toolParams : window.location.search
    };
    const callback_url = `${process.env.REACT_APP_SOCIAL_CALLBACK}/ttcallback`;
    const width = 599;
    const height = 599;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
    const features = `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`;
    window.open(`https://ads.tiktok.com/marketing_api/auth?app_id=${appid}&state=${encodeURIComponent(btoa(JSON.stringify(state)))}&redirect_uri=${encodeURIComponent(callback_url)}&rid=${rid}`, "childwindow", features);
  };

  return (
    <div style={{ display: "flex", flexWrap: "nowrap" }}>
      <div className={classes.tiktokButtonContainer} onClick={openNewTab}>
        <img src={TiktokLoginIcon} width="20" height="20" />
        <div className={classes.tiktokButton}>Login with TikTok for Business</div>
      </div>
      <div style={{ paddingLeft: "24px", marginTop: "10px", visibility: visibllity }}>
        <IconSuccess />
      </div>
    </div>
  );
};
